interface FetchErrorRequest {
    endpoint: string;
    method: string;
}

class FetchError extends Error {
    public readonly status: number;
    public readonly endpoint: string;
    public readonly method: string;
    public readonly response: Response;
    public readonly json: object;

    constructor(
        message: string,
        response: Response,
        json: object,
        request: FetchErrorRequest,
    ) {
        super(message);
        this.name = 'FetchError';
        this.status = response.status;
        this.endpoint = request.endpoint;
        this.method = request.method;
        this.response = response;
        this.json = json;
    }
}

export default FetchError;
